export const orderFormFields = {
  address: "address",
  fulfillmentDate: "fulfillmentDate",
  fulfillmentTime: "fulfillmentTime",
  fulfillmentTimeOther: "fulfillmentTimeOther",
  preferences: "preferences",
  serviceType: "serviceType",
  status: "status",
  step: "step",
  userId: "userId",
};
